var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationCaseSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "white",
    stroke: "#0F6E8C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8571 13.4286H22.567C23.0404 13.4286 23.4242 13.8123 23.4242 14.2857V22.8571C23.4242 23.3305 23.0404 23.7143 22.567 23.7143H10.8571C10.3838 23.7143 10 23.3305 10 22.8571V14.2857C10 13.8123 10.3838 13.4286 10.8571 13.4286Z",
    stroke: "#0F6E8C",
    strokeWidth: 0.923077
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.2857C10 12.4857 10.6293 11.7143 12.517 11.7143",
    stroke: "#0F6E8C",
    strokeWidth: 0.923077
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7235 8.84034L26.3876 9.15691L26.7235 8.84034ZM12.0554 13C12.0554 13.2549 12.2621 13.4615 12.517 13.4615C12.7719 13.4615 12.9785 13.2549 12.9785 13H12.0554ZM12.9785 23.7143C12.9785 23.4594 12.7719 23.2527 12.517 23.2527C12.2621 23.2527 12.0554 23.4594 12.0554 23.7143H12.9785ZM25.4963 7.53843L25.1604 7.85501L25.4963 7.53843ZM14.2313 30.6044H26.7439V29.6813H14.2313V30.6044ZM28.9197 28.4286V11.3613H27.9966V28.4286H28.9197ZM24.2488 6.53846H14.2313V7.46154H24.2488V6.53846ZM28.3272 9.86884L27.0593 8.52376L26.3876 9.15691L27.6555 10.502L28.3272 9.86884ZM27.0593 8.52376L25.8321 7.22185L25.1604 7.85501L26.3876 9.15691L27.0593 8.52376ZM12.0554 11.7857V13H12.9785V11.7857H12.0554ZM12.0554 23.7143V28.4286H12.9785V23.7143H12.0554ZM12.0554 8.71429V9.89286H12.9785V8.71429H12.0554ZM12.0554 9.89286V11.7857H12.9785V9.89286H12.0554ZM24.2488 7.46154C24.5939 7.46154 24.9237 7.60389 25.1604 7.85501L25.8321 7.22185C25.421 6.78571 24.8482 6.53846 24.2488 6.53846V7.46154ZM28.9197 11.3613C28.9197 10.8064 28.7078 10.2726 28.3272 9.86884L27.6555 10.502C27.8746 10.7344 27.9966 11.0418 27.9966 11.3613H28.9197ZM26.7439 30.6044C27.9456 30.6044 28.9197 29.6302 28.9197 28.4286H27.9966C27.9966 29.1204 27.4358 29.6813 26.7439 29.6813V30.6044ZM14.2313 29.6813C13.5394 29.6813 12.9785 29.1204 12.9785 28.4286H12.0554C12.0554 29.6302 13.0296 30.6044 14.2313 30.6044V29.6813ZM14.2313 6.53846C13.0296 6.53846 12.0554 7.51261 12.0554 8.71429H12.9785C12.9785 8.02241 13.5394 7.46154 14.2313 7.46154V6.53846Z",
    fill: "#0F6E8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2631 7V10.4286C24.2631 10.902 24.6468 11.2857 25.1202 11.2857H28.4581",
    stroke: "#0F6E8C",
    strokeWidth: 0.923077
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.7408V17.0314C19.9999 16.9126 19.969 16.7959 19.9105 16.6931C19.852 16.5903 19.7679 16.5049 19.6667 16.4455L17.3333 15.0907C17.232 15.0313 17.117 15 17 15C16.883 15 16.768 15.0313 16.6667 15.0907L14.3333 16.4455C14.2321 16.5049 14.148 16.5903 14.0895 16.6931C14.031 16.7959 14.0001 16.9126 14 17.0314V19.7408C14.0001 19.8596 14.031 19.9763 14.0895 20.0791C14.148 20.182 14.2321 20.2674 14.3333 20.3267L16.6667 21.6815C16.768 21.7409 16.883 21.7722 17 21.7722C17.117 21.7722 17.232 21.7409 17.3333 21.6815L19.6667 20.3267C19.7679 20.2674 19.852 20.182 19.9105 20.0791C19.969 19.9763 19.9999 19.8596 20 19.7408Z",
    stroke: "#0F6E8C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.09 16.6791L17 18.3895L19.91 16.6791",
    stroke: "#0F6E8C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 21.8V18.3861",
    stroke: "#0F6E8C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 28,
    r: 5,
    fill: "#0F6E8C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7778 26.3333L26.3403 29.7708L24.7778 28.2083",
    fill: "#0F6E8C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7778 26.3333L26.3403 29.7708L24.7778 28.2083",
    stroke: "white",
    strokeWidth: 0.888889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationCaseSuccess);
export default __webpack_public_path__ + "static/media/notification_case_success.c1ade347b18500a8e0b6b06cc6fa4d41.svg";
export { ForwardRef as ReactComponent };